"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _AuthContext = require("../context/AuthContext");
var _BulkApplyRunContext = require("../context/BulkApplyRunContext");
var _useDioptraFetch2 = require("../hooks/use-dioptra-fetch");
var _useScreenWakeLock = require("../hooks/useScreenWakeLock");
var _useProposalEngineEnabled = require("../hooks/use-proposal-engine-enabled");
var _useLiveProposal = require("../hooks/use-live-proposal");
var _useInsertionSlotOrdering = require("../hooks/use-insertion-slot-ordering");
var _useInsertionSlotLandings = require("../hooks/use-insertion-slot-landings");
var _redlineInsertionSlot = require("../utils/redline-insertion-slot");
var _insertionLandingsContext = require("../components/chat/proposal-card/insertion-landings-context");
var _ProposalEditsContext = require("../context/ProposalEditsContext");
var _proposalEditOverlay = require("../utils/proposal-edit-overlay");
var _cardNumbers = require("../components/chat/proposal-card/card-numbers");
var _ArtifactLinkContext = require("@common/components/ArtifactLinkContext");
var _LiveReviewStatusBar = _interopRequireDefault(require("../components/chat/LiveReviewStatusBar"));
var _WopiActionBar = _interopRequireDefault(require("../components/wopi/WopiActionBar"));
var _liveReview = require("@common/schemas/live-review");
var _ChatContext = require("../context/ChatContext");
var _WordDocumentContext = require("../context/WordDocumentContext");
var _ChatInput = require("../components/ChatInput");
var _button = require("@design/ui/button");
var _FilesPanel = require("../components/redline/FilesPanel");
var _VirtualizedMessageList = _interopRequireDefault(require("../components/chat/VirtualizedMessageList"));
var _PageContext = require("../context/PageContext");
var _ReviewedDocumentContext = require("../context/ReviewedDocumentContext");
var _SavedPromptsContext = require("../context/SavedPromptsContext");
var _useInitialPrompt = require("../hooks/useInitialPrompt");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _analytics = require("@common/analytics");
var _useFileDropSurface2 = require("@common/hooks/use-file-drop-surface");
var _ChatFileDropOverlay = require("@common/components/chat/ChatFileDropOverlay");
var _toast = require("../utils/toast");
var _envManager = require("../utils/envManager");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _zod = require("zod");
var _QuickActionsPanel = require("../components/chat/QuickActionsPanel");
var _ApplyAllActionsPanel = require("../components/chat/ApplyAllActionsPanel");
var _cardCollisions = require("@common/utils/redline/text/card-collisions");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _cardLiveProposal = require("../components/chat/proposal-card/card-live-proposal");
var _CardPreviewsContext = require("../components/chat/proposal-card/CardPreviewsContext");
var _SaveAllGuidelinesPanel = require("../components/chat/SaveAllGuidelinesPanel");
var _ReplayControls = require("../components/chat/ReplayControls");
var _useChatChrome2 = require("./hooks/use-chat-chrome");
var _useFileAttachments2 = require("./hooks/use-file-attachments");
var _useMessageFeedback2 = require("./hooks/use-message-feedback");
var _useGuidelineSuggestions = require("./hooks/use-guideline-suggestions");
var _useSuggestedActions2 = require("./hooks/use-suggested-actions");
var _useConversationArtifacts = require("./hooks/use-conversation-artifacts");
var _useMessageComposer2 = require("./hooks/use-message-composer");
var _chatMessageFiles = require("@common/schemas/chat-message-files");
var _sentMessageFiles = require("@common/components/chat/sentMessageFiles");
var _useMessageList2 = require("./hooks/use-message-list");
var _ChatPage = require("./ChatPage.styles");
var _WordSlowResponseNotice = require("../components/common/WordSlowResponseNotice");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // import { CardDetailsProvider } from "../components/chat/proposal-card/CardDetailsContext";
var AttachedConversationsResponseSchema = _zod.z.object({
  attachedConversations: _zod.z.array(_zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string()
  }))
});
var QUICK_ACTIONS_PANEL_COLLAPSED_RESERVED_HEIGHT = 46;
var QUICK_ACTIONS_PANEL_EXPANDED_RESERVED_HEIGHT = 346;
var ChatPage = function ChatPage() {
  var _attachedConversation, _engineAccess$authorN;
  var _usePage = (0, _PageContext.usePage)(),
    currentPage = _usePage.currentPage,
    pageParams = _usePage.pageParams,
    showPage = _usePage.showPage;
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    applyActiveReview = _useReviewedDocument.applyActiveReview;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError,
    analytics = _useAnalytics.analytics;
  var proposalEngineEnabled = (0, _useProposalEngineEnabled.useProposalEngineEnabled)();
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user,
    refreshAuthInfo = _useAuthInfo.refreshAuthInfo;
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  var webappFetch = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL")).concat(url), options));
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [dioptraFetch]);
  var virtuosoRef = (0, _react.useRef)(null);
  var _useChat = (0, _ChatContext.useChat)(),
    messagesHistory = _useChat.messagesHistory,
    selectedConversationId = _useChat.selectedConversationId,
    pendingScrollTarget = _useChat.pendingScrollTarget,
    setPendingScrollTarget = _useChat.setPendingScrollTarget,
    isConversationLoading = _useChat.isConversationLoading,
    isSelectedConversationJustCreated = _useChat.isSelectedConversationJustCreated,
    createAndSelectConversation = _useChat.createAndSelectConversation,
    markActionAsApplied = _useChat.markActionAsApplied,
    recordActionFailure = _useChat.recordActionFailure,
    isActionApplied = _useChat.isActionApplied,
    getActionAppliedAt = _useChat.getActionAppliedAt,
    markActionAsDismissed = _useChat.markActionAsDismissed,
    markActionAsRefused = _useChat.markActionAsRefused,
    clearActionRefusal = _useChat.clearActionRefusal,
    isActionRefused = _useChat.isActionRefused,
    markActionAsFailed = _useChat.markActionAsFailed,
    clearActionFailure = _useChat.clearActionFailure,
    getActionFailure = _useChat.getActionFailure,
    markActionAsSuperseded = _useChat.markActionAsSuperseded,
    getActionSupersession = _useChat.getActionSupersession,
    markActionAsPartlySuperseded = _useChat.markActionAsPartlySuperseded,
    getActionPartSupersession = _useChat.getActionPartSupersession,
    markActionAsRemovedFromConflictGroups = _useChat.markActionAsRemovedFromConflictGroups,
    isActionRemovedFromConflictGroups = _useChat.isActionRemovedFromConflictGroups,
    markActionAsUndismissed = _useChat.markActionAsUndismissed,
    isActionDismissed = _useChat.isActionDismissed,
    isActionDismissalSaving = _useChat.isActionDismissalSaving,
    getActionRecoveryWarning = _useChat.getActionRecoveryWarning,
    markActionWithRecoveryWarning = _useChat.markActionWithRecoveryWarning,
    updateMessageById = _useChat.updateMessageById,
    mergeMessageTurnArtifacts = _useChat.mergeMessageTurnArtifacts,
    streamingMessage = _useChat.streamingMessage,
    isPolling = _useChat.isPolling,
    pollDetectedActivity = _useChat.pollDetectedActivity,
    streamingConversationId = _useChat.streamingConversationId,
    clearStreamingConversation = _useChat.clearStreamingConversation,
    toolStatusByCallId = _useChat.toolStatusByCallId,
    sendMessage = _useChat.sendMessage,
    attachmentFiles = _useChat.attachmentFiles,
    inFocusFileRef = _useChat.inFocusFileRef,
    loadingFiles = _useChat.loadingFiles,
    handleAddFiles = _useChat.handleAddFiles,
    handleSelectSavedFile = _useChat.handleSelectSavedFile,
    attachPromptFilesToConversation = _useChat.attachPromptFilesToConversation,
    handleDeleteFileConfirm = _useChat.handleDeleteFileConfirm,
    handleRemoveFilesClick = _useChat.handleRemoveFilesClick,
    documentBackups = _useChat.documentBackups,
    conversationMatchesOpenDocument = _useChat.conversationMatchesOpenDocument,
    restoringBackupName = _useChat.restoringBackupName,
    revertDocumentToBackup = _useChat.revertDocumentToBackup;
  var _useFileAttachments = (0, _useFileAttachments2.useFileAttachments)({
      attachmentFiles: attachmentFiles,
      handleRemoveFilesClick: handleRemoveFilesClick,
      handleDeleteFileConfirm: handleDeleteFileConfirm
    }),
    showDeleteFileDialog = _useFileAttachments.showDeleteFileDialog,
    fileToDelete = _useFileAttachments.fileToDelete,
    handleDeleteFileCancel = _useFileAttachments.handleDeleteFileCancel,
    handleRemoveFilesClickWrapper = _useFileAttachments.handleRemoveFilesClickWrapper,
    handleDeleteFileConfirmWrapper = _useFileAttachments.handleDeleteFileConfirmWrapper,
    handleRemoveSavedFileWrapper = _useFileAttachments.handleRemoveSavedFileWrapper;
  var conversationId = selectedConversationId !== null && selectedConversationId !== void 0 ? selectedConversationId : "";
  var liveProposalRegistry = (0, _useLiveProposal.useLiveProposalRegistry)();
  (0, _react.useEffect)(function () {
    return function () {
      return liveProposalRegistry.forgetLastLivePreviews();
    };
  }, [conversationId, liveProposalRegistry]);
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    proposalEditsOf = _useProposalEdits.editsOf,
    clearProposalEdit = _useProposalEdits.clearEdit;
  var proposalEdits = proposalEditsOf(conversationId);
  var _useMessageFeedback = (0, _useMessageFeedback2.useMessageFeedback)({
      conversationId: conversationId
    }),
    copyClipboardIndicator = _useMessageFeedback.copyClipboardIndicator,
    savePromptIndicator = _useMessageFeedback.savePromptIndicator,
    showFeedbackFormForMessageId = _useMessageFeedback.showFeedbackFormForMessageId,
    setShowFeedbackFormForMessageId = _useMessageFeedback.setShowFeedbackFormForMessageId,
    handleSaveUserMessageAsPrompt = _useMessageFeedback.handleSaveUserMessageAsPrompt,
    handleCopyToClipboard = _useMessageFeedback.handleCopyToClipboard;
  var isComposerDisabled = !conversationId || isConversationLoading;
  var attachFiles = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(source, files) {
      var uploadedFileCount;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return handleAddFiles(files);
          case 1:
            uploadedFileCount = _context2.v;
            if (!(uploadedFileCount === 0)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            (0, _analytics.trackChatFilesAdded)(analytics, source, {
              surface: "word-addin",
              conversationId: conversationId,
              fileCount: uploadedFileCount
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [handleAddFiles, analytics, conversationId]);
  var filesAddedBeforeComposerReady = (0, _react.useRef)([]);
  var handleFilesAdded = function handleFilesAdded(source) {
    return function (files) {
      if (isComposerDisabled) {
        filesAddedBeforeComposerReady.current.push({
          conversationId: conversationId,
          source: source,
          files: files
        });
        return;
      }
      void attachFiles(source, files);
    };
  };
  (0, _react.useEffect)(function () {
    if (isComposerDisabled) return;
    var heldFileBatches = filesAddedBeforeComposerReady.current;
    filesAddedBeforeComposerReady.current = [];
    heldFileBatches.forEach(function (heldBatch) {
      if (heldBatch.conversationId && heldBatch.conversationId !== conversationId) {
        (0, _toast.toastWarning)("".concat(heldBatch.files.map(function (file) {
          return file.name;
        }).join(", "), " was not attached because you switched conversations."));
        return;
      }
      void attachFiles(heldBatch.source, heldBatch.files);
    });
  }, [isComposerDisabled, attachFiles, conversationId]);
  var _useFileDropSurface = (0, _useFileDropSurface2.useFileDropSurface)({
      isEnabled: true,
      onFilesDropped: handleFilesAdded("drop")
    }),
    isDraggingFiles = _useFileDropSurface.isDraggingFiles,
    fileDropSurfaceHandlers = _useFileDropSurface.surfaceHandlers;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectedText = _useWordDocument.selectedText,
    selectionOoxmlStripped = _useWordDocument.selectionOoxmlStripped,
    selectBookmarksRange = _useWordDocument.selectBookmarksRange,
    selectBookmarksRangeIfPresent = _useWordDocument.selectBookmarksRangeIfPresent,
    documentName = _useWordDocument.documentName;
  var _useSavedPrompts = (0, _SavedPromptsContext.useSavedPrompts)(),
    createPrompt = _useSavedPrompts.createPrompt;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    attachedConversationsByConversationId = _useState2[0],
    setAttachedConversationsByConversationId = _useState2[1];
  var attachedConversationsRevision = (0, _react.useRef)(0);
  var _useChatChrome = (0, _useChatChrome2.useChatChrome)({
      webappFetch: webappFetch,
      conversationId: conversationId,
      attachedConversationsRevision: attachedConversationsRevision,
      setAttachedConversationsByConversationId: setAttachedConversationsByConversationId
    }),
    showFilesPanel = _useChatChrome.showFilesPanel,
    setShowFilesPanel = _useChatChrome.setShowFilesPanel,
    handleRemoveConversation = _useChatChrome.handleRemoveConversation;
  var activeAttachedConversations = (_attachedConversation = attachedConversationsByConversationId[conversationId]) !== null && _attachedConversation !== void 0 ? _attachedConversation : [];
  (0, _react.useEffect)(function () {
    if (!conversationId) return;
    var loadRevision = ++attachedConversationsRevision.current;
    webappFetch("".concat(_useChatChrome2.ATTACHED_CONVERSATIONS_PATH, "?conversationId=").concat(conversationId)).then(function (response) {
      if (attachedConversationsRevision.current !== loadRevision) return;
      var _AttachedConversation = AttachedConversationsResponseSchema.parse(response),
        attachedConversations = _AttachedConversation.attachedConversations;
      setAttachedConversationsByConversationId(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, conversationId, attachedConversations));
      });
    }).catch(function (error) {
      sendError(error instanceof Error ? error : new Error(String(error)), {
        component: "ChatPage",
        action: "load_attached_conversations",
        conversationId: conversationId
      });
    });
  }, [conversationId, webappFetch, sendError]);
  var handleAttachConversation = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(conversation) {
      var _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            _context3.n = 1;
            return webappFetch(_useChatChrome2.ATTACHED_CONVERSATIONS_PATH, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                conversationId: conversationId,
                attachedConversationId: conversation.id
              })
            });
          case 1:
            attachedConversationsRevision.current += 1;
            setAttachedConversationsByConversationId(function (prev) {
              var _prev$conversationId;
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, conversationId, [].concat(_toConsumableArray((_prev$conversationId = prev[conversationId]) !== null && _prev$conversationId !== void 0 ? _prev$conversationId : []), [conversation])));
            });
            (0, _analytics.trackChatComposerEvent)({
              sink: analytics,
              surface: "word-addin",
              conversationId: conversationId
            }, {
              name: "chat_composer_past_chat_attached",
              attachedConversationId: conversation.id
            });
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t = _context3.v;
            (0, _toast.toastError)(_t);
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [conversationId, webappFetch, analytics]);
  var handleOpenLibrary = (0, _react.useCallback)(function (tab) {
    showPage(_PageContext.PAGES.libraryPage, {
      activeTab: tab
    });
  }, [showPage]);
  var filteredMessagesRef = (0, _react.useRef)([]);
  var restoreScrollTargetRef = (0, _react.useRef)(pendingScrollTarget);
  var isGeneratingStream = streamingConversationId === conversationId;
  var bulkApplyRun = (0, _BulkApplyRunContext.useBulkApplyRun)();
  var isLiveReviewRunning = messagesHistory.some(function (message) {
    return (0, _liveReview.parseRunningLiveReview)(message) !== null;
  });
  var isPollingBeforeAnyServerActivitySeen = isPolling && !pollDetectedActivity;
  var isLoading = isPollingBeforeAnyServerActivitySeen || bulkApplyRun.isRunning || isLiveReviewRunning;
  var isGenerating = isGeneratingStream || isPolling && pollDetectedActivity;
  (0, _useInsertionSlotOrdering.useInsertionSlotOrdering)({
    conversationId: selectedConversationId,
    turns: messagesHistory,
    agentIsAnswering: isGenerating,
    authHeader: authHeader,
    reportFailure: function reportFailure(failure) {
      return sendError(failure instanceof Error ? failure : new Error(String(failure)), {
        component: "ChatPage",
        action: "order_insertion_slots"
      });
    }
  });
  var insertionLandings = (0, _useInsertionSlotLandings.useInsertionSlotLandings)({
    conversationId: selectedConversationId,
    turns: messagesHistory,
    readingIsPaused: isGenerating || bulkApplyRun.isRunning,
    isActionApplied: isActionApplied,
    page: _redlineInsertionSlot.officeSlotPage,
    reportFailure: function reportFailure(failure) {
      return sendError(failure instanceof Error ? failure : new Error(String(failure)), {
        component: "ChatPage",
        action: "read_insertion_landings"
      });
    }
  });
  (0, _useScreenWakeLock.useScreenWakeLock)(isGenerating);
  var _useState3 = (0, _react.useState)(new Map()),
    _useState4 = _slicedToArray(_useState3, 2),
    _todoLists = _useState4[0],
    setTodoLists = _useState4[1];
  var messages = (0, _react.useMemo)(function () {
    var baseMessages = [_useMessageList2.firstMessage].concat(_toConsumableArray(messagesHistory.map(_useMessageList2.convertToExtendedMessage)));
    var allMessages = streamingMessage ? [].concat(_toConsumableArray(baseMessages), [streamingMessage]) : baseMessages;
    return proposalEngineEnabled ? (0, _proposalEditOverlay.withProposalEdits)(allMessages, proposalEdits) : allMessages;
  }, [messagesHistory, streamingMessage, proposalEngineEnabled, proposalEdits]);
  var _useGuidelineSuggesti = (0, _useGuidelineSuggestions.useGuidelineSuggestions)({
      messages: messages,
      toolStatusByCallId: toolStatusByCallId,
      isActionApplied: isActionApplied,
      isActionDismissed: isActionDismissed,
      markActionAsApplied: markActionAsApplied,
      markActionAsDismissed: markActionAsDismissed,
      conversationId: conversationId
    }),
    isGuidelinesPanelExpanded = _useGuidelineSuggesti.isGuidelinesPanelExpanded,
    setIsGuidelinesPanelExpanded = _useGuidelineSuggesti.setIsGuidelinesPanelExpanded,
    guidelinesToSave = _useGuidelineSuggesti.guidelinesToSave,
    handleGuidelineSaved = _useGuidelineSuggesti.handleGuidelineSaved,
    handleGuidelineDismissed = _useGuidelineSuggesti.handleGuidelineDismissed,
    handleToggleGuidelineSelection = _useGuidelineSuggesti.handleToggleGuidelineSelection,
    handleToggleSelectAllGuidelines = _useGuidelineSuggesti.handleToggleSelectAllGuidelines;
  var sentFileIds = (0, _react.useMemo)(function () {
    return (0, _chatMessageFiles.alreadySentAttachmentIds)(attachmentFiles, (0, _sentMessageFiles.lastUserTurnArtifacts)(messagesHistory, _sentMessageFiles.hasUserTurnType));
  }, [attachmentFiles, messagesHistory]);
  var hasNoConversationTurns = messagesHistory.length === 0 && !streamingMessage;
  var _useState5 = (0, _react.useState)(hasNoConversationTurns),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewConversation = _useState6[0],
    setIsNewConversation = _useState6[1];
  var isConversationLayoutSettled = isSelectedConversationJustCreated || !isConversationLoading;
  if (isConversationLayoutSettled && isNewConversation !== hasNoConversationTurns) setIsNewConversation(hasNoConversationTurns);
  var newChatGreeting = isNewConversation ? user !== null && user !== void 0 && user.firstName ? "How can I help you, ".concat(user.firstName, "?") : "How can I help you?" : null;
  var cardNumbers = (0, _react.useMemo)(function () {
    return (0, _cardNumbers.cardNumbersOf)(messages);
  }, [messages]);
  (0, _react.useEffect)(function () {
    return _cardNumbers.chatCardNumbers.publish(cardNumbers);
  }, [cardNumbers]);
  var _useSuggestedActions = (0, _useSuggestedActions2.useSuggestedActions)({
      authHeader: authHeader,
      selectionOoxmlStripped: selectionOoxmlStripped,
      updateMessageById: updateMessageById,
      clearActionRefusal: clearActionRefusal,
      clearActionFailure: clearActionFailure,
      clearProposalEdit: clearProposalEdit,
      markActionAsSuperseded: markActionAsSuperseded,
      setShowFeedbackFormForMessageId: setShowFeedbackFormForMessageId,
      sendError: sendError,
      messages: messages,
      toolStatusByCallId: toolStatusByCallId,
      isActionApplied: isActionApplied,
      getActionAppliedAt: getActionAppliedAt,
      isActionDismissed: isActionDismissed,
      getActionFailure: getActionFailure,
      isActionRefused: isActionRefused,
      markActionAsRefused: markActionAsRefused,
      markActionAsFailed: markActionAsFailed,
      markActionAsApplied: markActionAsApplied,
      markActionAsDismissed: markActionAsDismissed,
      markActionAsUndismissed: markActionAsUndismissed,
      proposalEngineEnabled: proposalEngineEnabled,
      conversationId: conversationId,
      cardNumbers: cardNumbers,
      getActionSupersession: getActionSupersession,
      getActionPartSupersession: getActionPartSupersession,
      isActionRemovedFromConflictGroups: isActionRemovedFromConflictGroups
    }),
    isQuickActionsPanelExpanded = _useSuggestedActions.isQuickActionsPanelExpanded,
    setIsQuickActionsPanelExpanded = _useSuggestedActions.setIsQuickActionsPanelExpanded,
    hasUnappliedUndismissedActions = _useSuggestedActions.hasUnappliedUndismissedActions,
    actionsToApply = _useSuggestedActions.actionsToApply,
    regeneratingToolResults = _useSuggestedActions.regeneratingToolResults,
    handleActionRefused = _useSuggestedActions.handleActionRefused,
    handleActionFailed = _useSuggestedActions.handleActionFailed,
    handleActionApplied = _useSuggestedActions.handleActionApplied,
    handleActionDismissed = _useSuggestedActions.handleActionDismissed,
    handleActionUndismissed = _useSuggestedActions.handleActionUndismissed,
    handleToggleSelection = _useSuggestedActions.handleToggleSelection,
    handleToggleSelectAll = _useSuggestedActions.handleToggleSelectAll,
    regenerateMessageRedline = _useSuggestedActions.regenerateMessageRedline,
    setActionsToApply = _useSuggestedActions.setActionsToApply;
  var copiedPromptIdRef = (0, _react.useRef)(null);
  var _useMessageComposer = (0, _useMessageComposer2.useMessageComposer)({
      conversationId: conversationId,
      restoreScrollTargetRef: restoreScrollTargetRef,
      setPendingScrollTarget: setPendingScrollTarget,
      filteredMessagesRef: filteredMessagesRef,
      virtuosoRef: virtuosoRef,
      sendError: sendError,
      sendMessage: sendMessage,
      setTodoLists: setTodoLists,
      clearStreamingConversation: clearStreamingConversation,
      createAndSelectConversation: createAndSelectConversation,
      currentPage: currentPage,
      pageParams: pageParams,
      authHeader: authHeader,
      copiedPromptIdRef: copiedPromptIdRef,
      attachPromptFilesToConversation: attachPromptFilesToConversation
    }),
    selectedModel = _useMessageComposer.selectedModel,
    setSelectedModel = _useMessageComposer.setSelectedModel,
    autoScrollEnabled = _useMessageComposer.autoScrollEnabled,
    setAutoScrollEnabled = _useMessageComposer.setAutoScrollEnabled,
    chatInputRef = _useMessageComposer.chatInputRef,
    handleSend = _useMessageComposer.handleSend,
    handleInterrupt = _useMessageComposer.handleInterrupt,
    clearInputsAndCreateNewConversation = _useMessageComposer.clearInputsAndCreateNewConversation;
  (0, _useInitialPrompt.useInitialPrompt)({
    initialPrompt: pageParams === null || pageParams === void 0 ? void 0 : pageParams.initialPrompt,
    autoSend: pageParams === null || pageParams === void 0 ? void 0 : pageParams.autoSend,
    agentOnlyContext: pageParams === null || pageParams === void 0 ? void 0 : pageParams.agentOnlyContext,
    conversationId: conversationId,
    isConversationLoading: isConversationLoading,
    sendMessage: handleSend,
    chatInput: chatInputRef
  });
  var _useConversationArtif = (0, _useConversationArtifacts.useConversationArtifacts)({
      webappFetch: webappFetch,
      markActionAsApplied: markActionAsApplied,
      sendError: sendError,
      markActionAsDismissed: markActionAsDismissed,
      mergeMessageTurnArtifacts: mergeMessageTurnArtifacts,
      createPrompt: createPrompt,
      handleSend: handleSend,
      applyActiveReview: applyActiveReview,
      setPendingScrollTarget: setPendingScrollTarget,
      showPage: showPage,
      conversationId: conversationId
    }),
    handleSaveCollectInputAnswer = _useConversationArtif.handleSaveCollectInputAnswer,
    handleSaveGuideline = _useConversationArtif.handleSaveGuideline,
    handleDismissGuideline = _useConversationArtif.handleDismissGuideline,
    handleSaveSkill = _useConversationArtif.handleSaveSkill,
    handleDismissSkill = _useConversationArtif.handleDismissSkill,
    handlePlaybookSelect = _useConversationArtif.handlePlaybookSelect,
    handleCreateNewPlaybook = _useConversationArtif.handleCreateNewPlaybook,
    handleOpenReview = _useConversationArtif.handleOpenReview;
  var handleActionSuperseded = (0, _react.useCallback)(function (actionId, supersededBy) {
    markActionAsSuperseded(conversationId, actionId, supersededBy);
    setActionsToApply(function (prev) {
      return prev.map(function (a) {
        return a.id === actionId ? _objectSpread(_objectSpread({}, a), {}, {
          supersededBy: supersededBy
        }) : a;
      });
    });
  }, [conversationId, markActionAsSuperseded, setActionsToApply]);
  var handleActionPartlySuperseded = (0, _react.useCallback)(function (actionId, partSupersededBy) {
    markActionAsPartlySuperseded(conversationId, actionId, partSupersededBy);
    setActionsToApply(function (prev) {
      return prev.map(function (a) {
        return a.id === actionId ? _objectSpread(_objectSpread({}, a), {}, {
          partSupersededBy: partSupersededBy
        }) : a;
      });
    });
  }, [conversationId, markActionAsPartlySuperseded, setActionsToApply]);
  var handleActionRemovedFromConflictGroups = (0, _react.useCallback)(function (actionId) {
    markActionAsRemovedFromConflictGroups(conversationId, actionId);
    setActionsToApply(function (prev) {
      return prev.map(function (a) {
        return a.id === actionId ? _objectSpread(_objectSpread({}, a), {}, {
          isRemovedFromConflictGroups: true
        }) : a;
      });
    });
  }, [conversationId, markActionAsRemovedFromConflictGroups, setActionsToApply]);
  var revertedActionIds = (0, _react.useMemo)(function () {
    return new Set(actionsToApply.filter(function (action) {
      return action.revertedInDocument;
    }).map(function (action) {
      return action.id;
    }));
  }, [actionsToApply]);
  var partlyRevertedActionIds = (0, _react.useMemo)(function () {
    return new Set(actionsToApply.filter(function (action) {
      return action.partlyRevertedInDocument;
    }).map(function (action) {
      return action.id;
    }));
  }, [actionsToApply]);
  var isActionStandingApplied = (0, _react.useCallback)(function (actionConversationId, actionId) {
    return isActionApplied(actionConversationId, actionId) && !revertedActionIds.has(actionId);
  }, [isActionApplied, revertedActionIds]);
  var pendingCollisionCards = (0, _react.useMemo)(function () {
    return (0, _ApplyAllActionsPanel.pendingCollisionCardsOf)(actionsToApply, messages);
  }, [actionsToApply, messages]);
  var potentialCollisionsByActionId = (0, _react.useMemo)(function () {
    var collisionsByActionId = new Map();
    var _iterator = _createForOfIteratorHelper((0, _cardCollisions.potentialCollisionsOfCards)(pendingCollisionCards)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _collisionsByActionId;
        var collision = _step.value;
        collisionsByActionId.set(collision.cardId, [].concat(_toConsumableArray((_collisionsByActionId = collisionsByActionId.get(collision.cardId)) !== null && _collisionsByActionId !== void 0 ? _collisionsByActionId : []), [collision]));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return collisionsByActionId;
  }, [pendingCollisionCards]);
  var engineAccess = (0, _useProposalEngineEnabled.useProposalEngineAccess)();
  var editAuthorName = (_engineAccess$authorN = engineAccess.authorName) !== null && _engineAccess$authorN !== void 0 ? _engineAccess$authorN : _redlineEngine.DIOPTRA_AUTHOR;
  var cardPreviews = (0, _react.useMemo)(function () {
    if (!engineAccess.enabled) return _CardPreviewsContext.NO_CARD_PREVIEWS;
    var collidingCardIds = new Set(Array.from(potentialCollisionsByActionId.values()).flat().map(function (collision) {
      return collision.otherCardId;
    }));
    var collidingActions = actionsToApply.filter(function (action) {
      return collidingCardIds.has(action.id);
    });
    var collidingCards = collidingActions.length === 0 ? [] : Array.from((0, _ApplyAllActionsPanel.trackerCardsOf)(collidingActions, messages, proposalEdits).values());
    var previewByActionId = new Map(collidingCards.flatMap(function (card) {
      var source = (0, _cardLiveProposal.cardPreviewSourceOfContent)(card.content, card.textRedlineBeforeEdit, card.textRedlineWhenOpened, editAuthorName);
      return source === null ? [] : [[card.actionId, (0, _cardLiveProposal.cardLivePreviewOf)(source)]];
    }));
    return {
      previewOf: function previewOf(actionId) {
        var _previewByActionId$ge;
        return (_previewByActionId$ge = previewByActionId.get(actionId)) !== null && _previewByActionId$ge !== void 0 ? _previewByActionId$ge : null;
      },
      signedInAuthorName: engineAccess.signedIn ? editAuthorName : null
    };
  }, [potentialCollisionsByActionId, actionsToApply, messages, proposalEdits, editAuthorName, engineAccess.signedIn, engineAccess.enabled]);
  var regeneratingToolResultIds = _toConsumableArray(regeneratingToolResults).sort().join(",");
  var _useMessageList = (0, _useMessageList2.useMessageList)({
      isGenerating: isGenerating,
      webappFetch: webappFetch,
      selectBookmarksRange: selectBookmarksRange,
      selectBookmarksRangeIfPresent: selectBookmarksRangeIfPresent,
      documentName: documentName,
      inFocusFileRef: inFocusFileRef,
      setAutoScrollEnabled: setAutoScrollEnabled,
      toolStatusByCallId: toolStatusByCallId,
      sendError: sendError,
      documentBackups: documentBackups,
      revertDocumentToBackup: revertDocumentToBackup,
      conversationMatchesOpenDocument: conversationMatchesOpenDocument,
      restoringBackupName: restoringBackupName,
      isActionApplied: isActionStandingApplied,
      revertedActionIds: revertedActionIds,
      partlyRevertedActionIds: partlyRevertedActionIds,
      isActionDismissed: isActionDismissed,
      isActionDismissalSaving: isActionDismissalSaving,
      markActionAsApplied: markActionAsApplied,
      recordActionFailure: recordActionFailure,
      markActionAsDismissed: markActionAsDismissed,
      markActionAsUndismissed: markActionAsUndismissed,
      getActionRecoveryWarning: getActionRecoveryWarning,
      getActionFailure: getActionFailure,
      markActionAsFailed: markActionAsFailed,
      markActionWithRecoveryWarning: markActionWithRecoveryWarning,
      regeneratingToolResults: regeneratingToolResults,
      regenerateMessageRedline: regenerateMessageRedline,
      showFeedbackFormForMessageId: showFeedbackFormForMessageId,
      setShowFeedbackFormForMessageId: setShowFeedbackFormForMessageId,
      handleSaveGuideline: handleSaveGuideline,
      handleDismissGuideline: handleDismissGuideline,
      handleSaveSkill: handleSaveSkill,
      handleDismissSkill: handleDismissSkill,
      handlePlaybookSelect: handlePlaybookSelect,
      handleCreateNewPlaybook: handleCreateNewPlaybook,
      handleSaveCollectInputAnswer: handleSaveCollectInputAnswer,
      handleSend: handleSend,
      handleOpenReview: handleOpenReview,
      handleCopyToClipboard: handleCopyToClipboard,
      handleSaveUserMessageAsPrompt: handleSaveUserMessageAsPrompt,
      copyClipboardIndicator: copyClipboardIndicator,
      savePromptIndicator: savePromptIndicator,
      messages: messages,
      filteredMessagesRef: filteredMessagesRef,
      virtuosoRef: virtuosoRef,
      conversationId: conversationId,
      cardNumbers: cardNumbers,
      potentialCollisionsByActionId: potentialCollisionsByActionId,
      cardPreviews: cardPreviews,
      getActionSupersession: getActionSupersession,
      getActionPartSupersession: getActionPartSupersession,
      regeneratingToolResultIds: regeneratingToolResultIds
    }),
    filteredMessages = _useMessageList.filteredMessages,
    activeLiveReview = _useMessageList.activeLiveReview,
    showLiveReviewBar = _useMessageList.showLiveReviewBar,
    liveReviewStartMs = _useMessageList.liveReviewStartMs,
    setDismissedLiveReviewRunKey = _useMessageList.setDismissedLiveReviewRunKey,
    handleScrollToAction = _useMessageList.handleScrollToAction,
    handleScrollToLiveReview = _useMessageList.handleScrollToLiveReview,
    computeItemKey = _useMessageList.computeItemKey,
    renderMessage = _useMessageList.renderMessage;
  var guidelinesPanelContent = (0, _SaveAllGuidelinesPanel.useSaveAllGuidelinesPanel)({
    guidelines: guidelinesToSave,
    conversationId: conversationId,
    onGuidelineSaved: handleGuidelineSaved,
    onGuidelineDismissed: handleGuidelineDismissed,
    onGuidelineClick: handleScrollToAction,
    onToggleSelection: handleToggleGuidelineSelection,
    onToggleSelectAll: handleToggleSelectAllGuidelines
  });
  var _useState7 = (0, _react.useState)(Number.POSITIVE_INFINITY),
    _useState8 = _slicedToArray(_useState7, 2),
    maxTrackerHeight = _useState8[0],
    setMaxTrackerHeight = _useState8[1];
  var actionsPanelContent = (0, _ApplyAllActionsPanel.useApplyAllActionsPanel)({
    actions: actionsToApply,
    messages: messages,
    conversationId: conversationId,
    maxTrackerHeight: maxTrackerHeight,
    onActionApplied: handleActionApplied,
    onActionClick: handleScrollToAction,
    onToggleSelection: handleToggleSelection,
    onToggleSelectAll: handleToggleSelectAll,
    onActionDismissed: handleActionDismissed,
    onActionUndismissed: handleActionUndismissed,
    onActionRefused: handleActionRefused,
    onActionFailed: handleActionFailed,
    onActionSuperseded: handleActionSuperseded,
    onActionPartlySuperseded: handleActionPartlySuperseded,
    onActionRemovedFromConflictGroups: handleActionRemovedFromConflictGroups,
    insertionPlaceOf: insertionLandings.placeOf
  });
  filteredMessagesRef.current = filteredMessages;
  function handleHeaderNewConversation() {
    return _handleHeaderNewConversation.apply(this, arguments);
  }
  function _handleHeaderNewConversation() {
    _handleHeaderNewConversation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var conversation;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return clearInputsAndCreateNewConversation();
          case 1:
            conversation = _context4.v;
            if (conversation) analytics === null || analytics === void 0 || analytics.track("chat_header_new_chat_created", {
              conversationId: conversation.id
            });
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _handleHeaderNewConversation.apply(this, arguments);
  }
  function handleHeaderOpenHistory() {
    analytics === null || analytics === void 0 || analytics.track("chat_header_history_opened", {
      conversationId: conversationId
    });
    showPage(_PageContext.PAGES.chatHistoryPage);
  }
  var headerChatActions = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "-mt-1.5 flex shrink-0 items-center justify-end gap-2 pr-9",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "icon",
      "aria-label": "New chat",
      title: "New chat",
      disabled: isNewConversation,
      onClick: handleHeaderNewConversation,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddCommentIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "icon",
      "aria-label": "Chat history",
      title: "Chat history",
      onClick: handleHeaderOpenHistory,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.HistoryIcon, {})
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChatPage.Container, _objectSpread(_objectSpread({
    className: "relative p-2"
  }, fileDropSurfaceHandlers), {}, {
    "data-sentry-element": "Container",
    "data-sentry-component": "ChatPage",
    "data-sentry-source-file": "ChatPage.tsx",
    children: [headerChatActions, /*#__PURE__*/(0, _jsxRuntime.jsx)(_WopiActionBar.default, {
      "data-sentry-element": "WopiActionBar",
      "data-sentry-source-file": "ChatPage.tsx"
    }), process.env.DIOPTRA_DEV_REPLAY === "true" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReplayControls.ReplayControls, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardPreviewsContext.CardPreviewsContext.Provider, {
      value: cardPreviews,
      "data-sentry-element": "CardPreviewsContext.Provider",
      "data-sentry-source-file": "ChatPage.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_insertionLandingsContext.InsertionLandingsContext.Provider, {
        value: insertionLandings,
        "data-sentry-element": "InsertionLandingsContext.Provider",
        "data-sentry-source-file": "ChatPage.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ArtifactLinkContext.ArtifactLinkProvider, {
          openArtifact: function openArtifact() {
            return setShowFilesPanel(true);
          },
          "data-sentry-element": "ArtifactLinkProvider",
          "data-sentry-source-file": "ChatPage.tsx",
          children: [!isNewConversation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualizedMessageList.default, {
            totalCount: filteredMessages.length,
            isFollowingOutput: autoScrollEnabled,
            onFollowOutputChange: setAutoScrollEnabled,
            renderMessage: renderMessage,
            computeItemKey: computeItemKey,
            listRef: virtuosoRef,
            bottomInset: hasUnappliedUndismissedActions && isQuickActionsPanelExpanded && actionsPanelContent.expandedContentHeight !== null ? actionsPanelContent.expandedContentHeight : 0,
            onViewportHeightChange: setMaxTrackerHeight,
            onJumpedToLatest: function onJumpedToLatest() {
              return analytics === null || analytics === void 0 ? void 0 : analytics.track("chat_jumped_to_latest", {
                conversationId: conversationId
              });
            }
          }), function () {
            var actionsVisible = hasUnappliedUndismissedActions;
            var guidelinesVisible = guidelinesToSave.length > 0;
            var actionsPanelExpandedHeight = actionsPanelContent.expandedContentHeight === null ? QUICK_ACTIONS_PANEL_EXPANDED_RESERVED_HEIGHT : QUICK_ACTIONS_PANEL_COLLAPSED_RESERVED_HEIGHT;
            var actionsPanelHeight = actionsVisible ? isQuickActionsPanelExpanded ? actionsPanelExpandedHeight : QUICK_ACTIONS_PANEL_COLLAPSED_RESERVED_HEIGHT : 0;
            var guidelinesPanelHeight = guidelinesVisible ? isGuidelinesPanelExpanded ? QUICK_ACTIONS_PANEL_EXPANDED_RESERVED_HEIGHT : QUICK_ACTIONS_PANEL_COLLAPSED_RESERVED_HEIGHT : 0;
            var totalHeight = actionsPanelHeight + guidelinesPanelHeight;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPage.QuickActionsPanelWrapper, {
              style: {
                height: "".concat(totalHeight, "px")
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "absolute bottom-0 left-0 right-0 mx-auto w-full min-[440px]:w-[80%] flex flex-col-reverse pointer-events-auto",
                children: [actionsVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "w-full",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickActionsPanel.QuickActionsPanel, {
                    isVisible: true,
                    isExpanded: isQuickActionsPanelExpanded,
                    onToggleExpanded: function onToggleExpanded() {
                      return setIsQuickActionsPanelExpanded(!isQuickActionsPanelExpanded);
                    },
                    title: actionsPanelContent.title,
                    actionButton: actionsPanelContent.button,
                    expandedContent: actionsPanelContent.expandedContent,
                    expandedContentHeight: actionsPanelContent.expandedContentHeight,
                    zIndex: 2
                  })
                }), guidelinesVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "w-full",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickActionsPanel.QuickActionsPanel, {
                    isVisible: true,
                    isExpanded: isGuidelinesPanelExpanded,
                    onToggleExpanded: function onToggleExpanded() {
                      return setIsGuidelinesPanelExpanded(!isGuidelinesPanelExpanded);
                    },
                    title: guidelinesPanelContent.title,
                    actionButton: guidelinesPanelContent.button,
                    expandedContent: guidelinesPanelContent.expandedContent,
                    zIndex: 3
                  })
                })]
              })
            });
          }(), activeLiveReview && showLiveReviewBar && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveReviewStatusBar.default, {
            playbookName: activeLiveReview.playbookName,
            status: activeLiveReview.status,
            checkedRules: activeLiveReview.checkedRules,
            totalRules: activeLiveReview.totalRules,
            startedAtMs: liveReviewStartMs,
            onExpand: function onExpand() {
              return handleScrollToLiveReview(activeLiveReview.runId, activeLiveReview.actionId);
            },
            onDismiss: function onDismiss() {
              return setDismissedLiveReviewRunKey(activeLiveReview.runKey);
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChatPage.ChatInputWrapper, {
            className: isNewConversation ? "flex flex-1 min-h-0 flex-col" : undefined,
            "data-sentry-element": "ChatInputWrapper",
            "data-sentry-source-file": "ChatPage.tsx",
            children: [function (_inFocusFileRef$curre, _inFocusFileRef$curre2) {
              var inFocusTokens = (_inFocusFileRef$curre = (_inFocusFileRef$curre2 = inFocusFileRef.current) === null || _inFocusFileRef$curre2 === void 0 ? void 0 : _inFocusFileRef$curre2.tokenCount) !== null && _inFocusFileRef$curre !== void 0 ? _inFocusFileRef$curre : 0;
              var attachmentTokens = attachmentFiles.reduce(function (sum, file) {
                return sum + (file.tokenCount || 0);
              }, 0);
              var totalTokens = inFocusTokens + attachmentTokens;
              var isOverSubAgentLimit = totalTokens > 500000;
              if (isOverSubAgentLimit) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChatPage.InfoBanner, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: "\u2139\uFE0F"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                    children: ["Total files exceed 500k tokens (", totalTokens.toLocaleString(), " total). This may affect accuracy. We will instruct the agent to use sub agents to handle each attachment individually."]
                  })]
                });
              }
              return null;
            }(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_WordSlowResponseNotice.WordSlowResponseNotice, {
              surface: "chat",
              "data-sentry-element": "WordSlowResponseNotice",
              "data-sentry-source-file": "ChatPage.tsx"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatInput.ChatInput, {
              ref: chatInputRef,
              onSubmit: handleSend,
              greeting: newChatGreeting,
              selectedModel: selectedModel,
              onModelChange: setSelectedModel,
              onOpenLibrary: handleOpenLibrary,
              onAgentSettingsSaved: refreshAuthInfo,
              onOpenHistory: function onOpenHistory() {
                return showPage(_PageContext.PAGES.chatHistoryPage);
              },
              onNewConversation: clearInputsAndCreateNewConversation,
              disabled: isComposerDisabled,
              selectedFiles: attachmentFiles,
              sentFileIds: sentFileIds,
              loadingFiles: loadingFiles,
              onRemoveFiles: handleRemoveFilesClickWrapper,
              onOpenFilesPanel: function onOpenFilesPanel() {
                return setShowFilesPanel(true);
              },
              onAttachConversation: handleAttachConversation,
              attachedConversations: activeAttachedConversations,
              onRemoveConversation: handleRemoveConversation,
              isGenerating: isGenerating,
              isLoading: isLoading,
              conversationId: conversationId,
              onInterrupt: handleInterrupt,
              onFilesPasted: handleFilesAdded("paste"),
              "data-sentry-element": "ChatInput",
              "data-sentry-source-file": "ChatPage.tsx"
            })]
          }), showFilesPanel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FilesPanel.FilesPanel, {
            onClose: function onClose() {
              return setShowFilesPanel(false);
            },
            onAddFiles: handleAddFiles,
            onSelectSavedFile: handleSelectSavedFile,
            isOpen: showFilesPanel,
            selectedFiles: attachmentFiles,
            onRemoveFiles: handleRemoveFilesClickWrapper,
            onRemoveSavedFile: handleRemoveSavedFileWrapper
          }), showDeleteFileDialog && fileToDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
            tone: "destructive",
            title: "Confirm remove",
            message: "Are you sure you want to remove \"".concat(fileToDelete.fileName, "\" from this conversation?"),
            confirmLabel: "Remove",
            onConfirm: handleDeleteFileConfirmWrapper,
            onCancel: handleDeleteFileCancel
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatFileDropOverlay.ChatFileDropOverlay, {
      isVisible: isDraggingFiles,
      "data-sentry-element": "ChatFileDropOverlay",
      "data-sentry-source-file": "ChatPage.tsx"
    })]
  }));
};
var _default = exports.default = ChatPage;